// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__VvbEH","disclaimerContainer":"styles_disclaimerContainer__GUp_L","link":"styles_link__YHBQx","willBeReplaced":"styles_willBeReplaced__4pRA_"};